import React from 'react';
import { string, bool, func, number } from 'prop-types';
import { DeliveryOptions } from '@thd-olt-component-react/delivery-options';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';

const OffshoreSthUnavailable = ({
  itemId,
  quantity,
  onDeliveryOptionChange,
  isDeliveryOptionChanged,
  stateName
}) => {

  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Home"
          icon="pick-up-false"
        />
        <div>Not available in {stateName}</div>
      </div>
      <TileFooter>
        <DeliveryOptions
          itemId={itemId}
          quantity={quantity}
          onZipCodeChange={onDeliveryOptionChange}
          visible={isDeliveryOptionChanged}
        >
          Change Zip
        </DeliveryOptions>
      </TileFooter>
    </>
  );
};
OffshoreSthUnavailable.propTypes = {
  itemId: string.isRequired,
  quantity: number,
  stateName: string,
  onDeliveryOptionChange: func,
  isDeliveryOptionChanged: bool
};
OffshoreSthUnavailable.defaultProps = {
  stateName: null,
  quantity: 1,
  isDeliveryOptionChanged: false,
  onDeliveryOptionChange: () => {}
};

export { OffshoreSthUnavailable };
